import React from "react";
import { Card, ListGroup, Row, Col } from "react-bootstrap";
import MultiCommanderIcon from "./icons/MultiCommanderIcon.png";
import DoubleCommanderIcon from "./icons/DoubleCommanderIcon.png";
import TotalCommanderIcon from "./icons/TotalCommanderIcon.png";
import SevenZipIcon from "./icons/7zipIcon.png";
import PeaZipIcon from "./icons/PeaZipIcon.png";
import GimpIcon from "./icons/GimpIcon.png";
import InkscapeIcon from "./icons/InkscapeIcon.png";
import OctaveIcon from "./icons/OctaveIcon.png";
import WinRar from "./icons/WinrarIcon.png";
import WinZip from "./icons/WinzipIcon.png";
import Matlab from "./icons/MatlabIcon.jpeg";

function OdporucanySoftver() {
  return (
    <div className="container mt-4">
      <h1 className="text-center">Odporúčaný softvér</h1>
      <hr className="mb-4" style={{ color: "#999999", height: "5px" }} />

      <Row>
        <Col md={6}>
          <Card className="mb-3">
            <Card.Header as="h4">File Manager</Card.Header>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <img src={TotalCommanderIcon} alt="Total Commander" width={30} className="me-2"/>
                <strong>Total Commander</strong> (Shareware) - Výkonný správca súborov s dvojpanelovým rozhraním. 
                <a href="https://www.ghisler.com/" target="_blank" rel="noopener noreferrer"> ghisler.com</a>
              </ListGroup.Item>
              <ListGroup.Item>
                <img src={MultiCommanderIcon} alt="Multi Commander" width={30} className="me-2"/>
                <strong>Multi Commander</strong> (GNU) - Alternatíva k Total Commanderu s množstvom funkcií. 
                <a href="http://multicommander.com/" target="_blank" rel="noopener noreferrer"> multicommander.com</a>
              </ListGroup.Item>
              <ListGroup.Item>
                <img src={DoubleCommanderIcon} alt="Double Commander" width={30} className="me-2"/>
                <strong>Double Commander</strong> (GNU) - Open-source správca súborov inšpirovaný Total Commanderom. 
                <a href="https://doublecmd.sourceforge.io/" target="_blank" rel="noopener noreferrer"> doublecmd.sourceforge.io</a>
              </ListGroup.Item>
              <ListGroup.Item>
              <img src={WinRar} alt="WinRar" width={30} className="me-2"/>
                <strong>WinRar</strong> & 
                <img src={WinZip} alt="WinZip" width={30} className="me-2"/>
                <strong>WinZip</strong> (Shareware) - Populárne nástroje na prácu s archívmi.
              </ListGroup.Item>
              <ListGroup.Item>
                <img src={SevenZipIcon} alt="7-Zip" width={30} className="me-2"/>
                <strong>7-Zip</strong> (GNU) - Výkonný a bezplatný nástroj na kompresiu súborov. 
                <a href="https://7-zip.org/" target="_blank" rel="noopener noreferrer"> 7-zip.org</a>
              </ListGroup.Item>
              <ListGroup.Item>
                <img src={PeaZipIcon} alt="PeaZip" width={30} className="me-2"/>
                <strong>PeaZip</strong> (GNU) - Open-source archivátor podporujúci množstvo formátov. 
                <a href="https://peazip.github.io/" target="_blank" rel="noopener noreferrer"> peazip.github.io</a>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>

        <Col md={6}>
          <Card className="mb-3">
            <Card.Header as="h4">Grafika</Card.Header>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <img src={GimpIcon} alt="GIMP" width={30} className="me-2"/>
                <strong>GIMP</strong> (GNU) - Výkonný editor obrázkov, open-source alternatíva k Photoshopu. 
                <a href="https://www.gimp.org/" target="_blank" rel="noopener noreferrer"> gimp.org</a>
              </ListGroup.Item>
              <ListGroup.Item>
                <img src={InkscapeIcon} alt="Inkscape" width={30} className="me-2"/>
                <strong>Inkscape</strong> (GNU) - Profesionálny editor vektorovej grafiky. 
                <a href="https://inkscape.org/" target="_blank" rel="noopener noreferrer"> inkscape.org</a>
              </ListGroup.Item>
            </ListGroup>
          </Card>

          <Card className="mb-3">
            <Card.Header as="h4">Programovanie</Card.Header>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <img src={Matlab} alt="Matlab" width={30} className="me-2"/>
                <strong>Matlab</strong> - Výkonné výpočtové prostredie, ale platené.
              </ListGroup.Item>
              <ListGroup.Item>
                <img src={OctaveIcon} alt="Octave" width={30} className="me-2"/>
                <strong>Octave</strong> (GNU) - Open-source alternatíva k Matlabu. 
                <a href="https://octave.org/" target="_blank" rel="noopener noreferrer"> octave.org</a>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default OdporucanySoftver;
